/**
 * Normaliza los errores de validación de FastAPI (HTTP 422) antes de que lleguen a
 * las pantallas.
 *
 * FastAPI responde 422 con `detail` como LISTA de objetos `{loc, msg, type}`. Casi
 * todas las pantallas hacen `toast.error(error.response?.data?.detail || '…')`: con
 * una lista, React intenta pintar objetos y se cae, y el aplicativo queda en blanco
 * (radicado 1246, 2026-10-08). Aquí la lista se convierte en texto legible.
 *
 * Solo se tocan las LISTAS: hay endpoints que devuelven `detail` como objeto a
 * propósito (p. ej. 409 PREDIO_ELIMINADO en Predios.js) y esos quedan intactos.
 */
export function detalleEnTexto(detail) {
  if (!Array.isArray(detail)) return detail;
  const partes = detail.map((d) => {
    if (d && typeof d === 'object') {
      const campo = Array.isArray(d.loc) ? d.loc.filter((x) => x !== 'body').join('.') : '';
      return [campo, d.msg].filter(Boolean).join(': ') || 'Dato inválido';
    }
    return String(d);
  });
  return partes.length ? `Datos inválidos — ${partes.join(' · ')}` : 'Datos inválidos';
}

export function normalizarErrorApi(error) {
  const data = error?.response?.data;
  if (data && Array.isArray(data.detail)) {
    data.detail = detalleEnTexto(data.detail);
  }
  return Promise.reject(error);
}
